import config from "@config"
import title1SmImg from "@images/1x/25aa.png"
import title2SmImg from "@images/1x/26aa.png"
import title3SmImg from "@images/1x/27aa.png"
import title4SmImg from "@images/1x/28aa.png"
import title5SmImg from "@images/1x/29aa.png"
import title2Img from "@images/2x/11aa.png"
import title3Img from "@images/2x/12aa.png"
import btnGuideImg from "@images/2x/13aa.png"
import title4Img from "@images/2x/14aa.png"
import showcaseImg from "@images/2x/15aa.png"
import title5Img from "@images/2x/16aa.png"
import btn2021Img from "@images/2x/17aa.png"
import title1Img from "@images/2x/7aa.png"
import btnJoinImg from "@images/update0511/40aa.png"
import btnTeamImg from "@images/update0511/41aa.png"
import btnWechatImg from "@images/update0511/42aa.png"
import Clickable from "@src/components/clickable"
import { ItemSection } from "@src/components/tabs/itemSection"
import React from "react"

const Flow = () => {
  return (
    <>
      <ItemSection pc={title1Img} app={title1SmImg}>
        <p>
          本次活动需要你以<strong>“队伍”</strong>
          的形式进行报名（队伍人数没有限制，可以是多人也可以是单人。）报名成功后会进入本次的活动群，方便大家进行交流以及后续消息通知。
        </p>
        <p>
          <Clickable
            appNavTo={config.links.enroll}
            className="img-btn"
            disabled
          >
            <img src={btnJoinImg} alt="join" />
          </Clickable>
        </p>

        <p>
          <strong className="smTitle">【组队人数限制】</strong>
          <br />
          本次活动需要你以“队伍”的形式进行报名，队伍人数没有限制，可以是多人也可以是单人。
          <br />
          我们不限制你同时参与创作团队的数量，但需要你自行协调好个人时间，同时你需要告知这些团队你处于多团队中。
        </p>
        <p>
          <strong className="smTitle">【线上组队处】</strong>
          <br />
          如果你想正在寻找一起开发的队伍，可以通过"线上组队处"寻找队友，然后再以“队伍”的形式由队长
          进行报名哦～
        </p>
        <p>
          <Clickable
            appNavTo={config.links.team}
            disabled
            className="img-btn mr-3"
          >
            <img src={btnTeamImg} alt="team" />
          </Clickable>
          <Clickable
            appNavTo={config.links.wechat}
            className="img-btn mr-3"
            disabled
          >
            <img src={btnWechatImg} alt="wechat" />
          </Clickable>
        </p>
      </ItemSection>
      <ItemSection pc={title2Img} app={title2SmImg}>
        <p>
          我们将于<strong>3月21日 8:00</strong>在BOOOM
          官网及机核网上公布本次开发主题，欢迎各位根据自己的喜好进行解读，并开启你们的游戏开发之旅。
        </p>
        <p>
          自公布 BOOOM 主题起，开发创作阶段便开始了，投稿截止时间为
          <strong>4月17日的24点（延长至5月4日24点前提交即可）</strong>
          ，因此你需要在 deadline
          前将游戏以及简介一并完成，并根据后续公布的要求进行提交。
        </p>
        <p>
          <strong className="smTitle">【开发者交流群】</strong>
          <br />
          开发过程中，我们和所有开发者共建了一个微信群，用于通知活动后续消息，也便于互相交流沟通想法与创意。（未进群的小伙伴请让组长拉你进群）
        </p>
      </ItemSection>
      <ItemSection pc={title3Img} app={title3SmImg}>
        <p>
          在<strong>4月15日～17日24:00（延长至5月4日24:00）</strong>使用
          BOOOM官网上的“提交游戏”功能自行上传。
          <br />
          在上传前可阅读以下“游戏上传指南”，提前将素材准备好，以免错过上传时间。
        </p>
        <p>
          <Clickable appNavTo={config.links.guide} className="img-btn">
            <img src={btnGuideImg} alt="guide" />
          </Clickable>
        </p>
      </ItemSection>
      <ItemSection pc={title4Img} app={title4SmImg}>
        <p>
          <strong className="smTitle">【线下延期通知】</strong>
          <br />
          由于疫情原定于5月核聚变北京站的展出计划将整体延期，目前依然在策划更多线下展示的机会，更多详情将在后续放出。当核聚变2022北京站恢复后，BOOOM在核聚变内的展出计划依然会照常进行。
        </p>
        <p>
          在5月份北京站核聚变现场，我们准备了 BOOOM
          游戏展区，为每个开发组准备了独立展示摊位，可以按照游戏特点进行布置展示；
        </p>

        <p>
          <img src={showcaseImg} alt="现场" />
        </p>

        <p>
          核聚变现场BOOOM展区，摊位数量有限，将按照开发者报名顺序安排摊位；没有摊位或者不能来现场的小伙伴也不用担心，我们会将这些游戏集成在一起进行展示，玩家将根据你给到的游戏操作说明，自行体验。
        </p>
      </ItemSection>
      <ItemSection pc={title5Img} app={title5SmImg}>
        <p>
          为了能够让所有的创意都有机会被更多人看见，我们会将 BOOOM
          期间收到的作品放到官网上的“下载试玩”区域，并进行开放，供不能来核聚变现场的玩家们进行体验，欢迎大家都来玩玩看～
        </p>
        <p>
          <Clickable appNavTo={config.links.event2021Games} className="img-btn">
            <img src={btn2021Img} alt="2021" />
          </Clickable>
        </p>
      </ItemSection>
    </>
  )
}

export default Flow
